module.exports = __webpack_public_path__ + "img/Eigentumswohnungen_multilingual_01.4c988958.png";